//  For each product on the page
document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;


    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    /* 26 Sep 2026 perf (INP-5): pin the gallery frame BEFORE Swiper is built.
       The frame takes the first slide's ratio, or the selected variant's own
       slide when that one is taller (amla 32 oz, turmeric 16 oz: portrait
       renders in an otherwise square set), so the shot the page opens on is
       never shrunk to fit. The section prints each image's aspect-ratio
       inline, so this is a style read, not a layout read. Pre-init the frame
       is already exactly one slide tall (the other slides are display:none
       until .swiper-initialized lands), so the first-slide case moves
       nothing on load, and the taller-variant case moves exactly what
       autoHeight moved before. Without this, dropping autoHeight would make
       the frame as tall as the TALLEST slide once every slide joins the flex
       row, and a product whose first shot is not its tallest would jump at
       init. Any other shot with a different ratio fits inside the frame
       (main-product.css, FIXED GALLERY FRAME). pdp-v2 sets its own 1:1 frame
       in pdp-v2.css, which outranks this property.
       26 Sep 2026 (INP5-V1): the same rule runs again on every variant
       change (goToVariantImage), so a size whose render is taller than the
       frame grows the frame to fit it and picking a square size again
       shrinks it back: turmeric 16 oz and amla 8/16 oz show at full width,
       as autoHeight showed them, instead of pillarboxed inside slide 1's
       frame. Still a style read of the inline ratio, one string compare,
       and a style write only when the ratio actually changes; on a
       single-ratio gallery (66 of 68) a size change writes nothing. Arrow
       taps never touch the frame. */
    /* 27 Sep 2026 (perf audit CODE-04 / LCP-06): ONE gallery per page.
       On pdp-v2 / pdp-v3 the section marks the stage data-gallery="pdp-v2"
       and pdp-v2.js builds the only Swiper there (thumb rail + lightbox).
       This file used to build one first, which pdp-v2.js destroyed and
       rebuilt with autoHeight: on Hibiscus at 4x CPU that was a load-time
       LoAF of 621-811 ms and a size choose of 2,368 ms (INP median). Here
       it only keeps the frame and the variant moves, against whichever
       instance is live; if pdp-v2.js never builds (it failed to load), the
       base gallery below is built at DOMContentLoaded instead, so the page
       is never left without one. data-first-slide is the slide the section
       painted first (the selected variant's shot, FIRST-FRAME CONTRACT):
       every instance opens there, so nothing jumps after load. */
    var galleryRoot = section.querySelector(".productVisualSwiper");
    var galleryOwned = !!(galleryRoot && galleryRoot.getAttribute("data-gallery") === "pdp-v2" &&
        document.body.classList.contains("pdp-v2"));
    var firstSlide = galleryRoot ? (parseInt(galleryRoot.getAttribute("data-first-slide"), 10) || 0) : 0;

    function slideRatio(slide) {
        var media = slide && slide.querySelector("img, video");
        var ratio = 0;
        if (media && media.style && media.style.aspectRatio) {
            var parts = String(media.style.aspectRatio).split("/");
            var w = parseFloat(parts[0]);
            var h = parts.length > 1 ? parseFloat(parts[1]) : 1;
            if (w > 0 && h > 0) ratio = w / h;
        }
        if (!ratio && media && media.naturalWidth > 0 && media.naturalHeight > 0) {
            ratio = media.naturalWidth / media.naturalHeight;
        }
        if (!ratio && slide) {
            var box = slide.getBoundingClientRect();
            if (box.width > 0 && box.height > 0) ratio = box.width / box.height;
        }
        return ratio;
    }
    /* 27 Sep 2026: pdp-v2/v3 run the SAME rule against their own base, the
       designed 1:1 stage (pdp-v2.css reads var(--fgo-gallery-ar, 1)), in
       place of pdp-v2's autoHeight, which measured the active slide on every
       arrow tap and size change (theme-swiper-bundle updateAutoHeight 215 ms
       over 2,052 elements per size choose at 4x). A variant shot taller than
       square grows the stage; every other slide fits inside it. The value
       the section printed (main-product.liquid, same rule) seeds frameRatio,
       so the first run writes nothing. */
    var baseRatio = -1;      /* slide 1's ratio, read once: a video slide carries no inline ratio and would need a layout read each time */
    var frameRatio = (function () {  /* what --fgo-gallery-ar holds now, so an unchanged ratio costs no style write */
        var v = galleryRoot ? parseFloat(galleryRoot.style.getPropertyValue("--fgo-gallery-ar")) : NaN;
        return v > 0 ? String(v) : (galleryOwned ? "1" : "");
    })();
    function fitGalleryFrame(idx) {
        var root = section.querySelector(".productVisualSwiper");
        var slides = root ? root.querySelectorAll(".productVisualSwiperSlide") : [];
        if (!slides.length) return;
        if (baseRatio < 0) baseRatio = galleryOwned ? 1 : (slideRatio(slides[0]) || 0);
        var ratio = baseRatio;
        if ((idx > 0 || (galleryOwned && idx === 0)) && idx < slides.length) {
            var own = slideRatio(slides[idx]);
            if (own > 0 && (!ratio || own < ratio)) ratio = own;
        }
        if (!(ratio > 0)) return;
        var value = String(ratio);
        if (value === frameRatio) return;
        frameRatio = value;
        root.style.setProperty("--fgo-gallery-ar", value);
    }
    fitGalleryFrame(variantSlideIndex(activeVariant));

    /* 26 Sep 2026 perf (INP-5): no autoHeight and no loop. autoHeight
       re-measured the active slide and rewrote the wrapper height on every
       arrow tap and size change, a forced layout each time (267-706 ms per
       arrow tap at 4x CPU on production), and the height change then fed
       Swiper's ResizeObserver, which ran a full update() on top; the frame
       is a fixed box now (fitGalleryFrame above). loop:true made loopFix
       move slides in the DOM and re-measure them all on every tap. rewind
       keeps what visitors had: the arrows and a long swipe wrap at both
       ends, and neither arrow is ever disabled. No clone slides either, so
       the pdp-v2 rebuild has nothing to strip. */
    var baseOptions = {
        slidesPerView: 1,
        spaceBetween: 20,
        rewind: true,
        initialSlide: firstSlide,   /* 27 Sep 2026: open on the slide the section painted first */
        // pagination: {
        //     el: section.querySelector('.swiper-pagination'),
        //     clickable: true,
        // },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        scrollbar: {
            el: section.querySelector(".swiper-scrollbar"),
            draggable: true,
        },
        on: {
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }

                // pause all videos
                section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    };
    var productSwiper = null;
    function buildBaseGallery() {
        if (!galleryRoot || galleryRoot.swiper) return;
        productSwiper = new Swiper(galleryRoot, baseOptions);
    }
    if (!galleryOwned) {
        buildBaseGallery();
    } else {
        /* deferred scripts have all run by now: pdp-v2.js has built its
           gallery unless it failed, in which case this one stands in */
        document.addEventListener("DOMContentLoaded", buildBaseGallery);
    }

    /* Move the gallery to a variant's own image.
       Matches by FILENAME first and only falls back to featured_image.position:
       position indexes product.images, while the slides are built from
       product.media, and the two diverge the moment a video is added.
       26 Sep 2026 perf (INP-5): does nothing when the gallery already shows
       that slide (every quantity tap and plan pick lands here too), and the
       old "update() then slide again" retry is gone with loop mode: slide
       geometry comes from the container width, not from image loading, so
       one slideTo lands. */
    function liveSwiper() {
        /* pdp-v2.js DESTROYS the instance created above and builds its own
           gallery (thumbnail rail + zoom), so the captured `productSwiper` is
           dead on the v2 template — calls against it fail silently, which is
           exactly why the price updated but the image never moved. Always
           read the instance currently attached to the element. */
        var root = section.querySelector(".productVisualSwiper");
        var sw = root && root.swiper ? root.swiper : productSwiper;
        return sw && !sw.destroyed ? sw : null;
    }

    function variantSlideIndex(variant) {
        if (!variant || !variant.featured_image) return -1;
        /* Shopify inserts a size suffix BEFORE the extension
           (spearmint_40_ct_front_1000x.webp), so the rendered src never
           contains the raw filename — compare on the base name.
           27 Sep 2026: an EXACT base-name match wins over a substring one.
           The substring test alone sent Ceylon's 8 oz (Untitled_1.png) to
           the 16 oz shot (Untitled_1_7755a101-....png, slide 1), which now
           that the page opens on the right slide would have been a jump away
           from it after load. The substring match stays as the fallback. */
        var fileBase = function (src) {
            var f = String(src || "").split("?")[0].split("/").pop();
            return f.replace(/\.[a-z0-9]+$/i, "").replace(/_\d*x\d*$/i, "");
        };
        var base = fileBase(variant.featured_image.src);
        var slides = section.querySelectorAll(".productVisualSwiperSlide");
        var idx = -1, loose = -1;
        for (var i = 0; i < slides.length; i++) {
            var im = slides[i].querySelector("img");
            if (!im) continue;
            var own = fileBase(im.getAttribute("src"));
            if (own === base) { idx = i; break; }
            if (loose < 0 && String(im.getAttribute("src")).indexOf(base) > -1) loose = i;
        }
        if (idx < 0) idx = loose;
        if (idx < 0) idx = variant.featured_image.position - 1;
        return idx;
    }

    function goToVariantImage(variant, speed) {
        var idx = variantSlideIndex(variant);
        if (idx < 0) return;
        /* INP5-V1: re-fit the frame to this variant's own shot BEFORE the
           move (and before the already-there check, in case the visitor
           arrowed onto that slide first), so a taller render and its frame
           land in one paint. A no-op unless the ratio differs. */
        fitGalleryFrame(idx);
        var sw = liveSwiper();
        if (!sw) return;
        /* already there: nothing to move. realIndex and activeIndex agree
           without loop mode; realIndex still covers an instance that runs
           its own loop (pdp-v2's does not). */
        var cur = typeof sw.realIndex === "number" ? sw.realIndex : sw.activeIndex;
        if (cur === idx) return;
        if (sw.params && sw.params.loop && typeof sw.slideToLoop === "function") {
            sw.slideToLoop(idx, speed);
        } else {
            sw.slideTo(idx, speed);
        }
    }

    /* 25 Sep perf: the gallery move is the expensive part of a size change
       (Swiper's loopFix and autoHeight read layout). It now runs AFTER the
       price and the button have been written and painted: a frame, then a
       task, so the shopper sees the new price first and the interaction's
       frame carries no gallery work. The end state is the same. Only the
       latest request runs, so a quick double change cannot land late on the
       earlier size. */
    var imageSeq = 0;
    function scheduleVariantImage(variant) {
        var seq = ++imageSeq;
        var run = function () { if (seq === imageSeq) goToVariantImage(variant); };
        if (typeof requestAnimationFrame === "function") {
            requestAnimationFrame(function () { setTimeout(run, 0); });
        } else {
            setTimeout(run, 0);
        }
    }

    // open on the selected variant's image: ?variant= deep links select a
    // variant server-side, but the gallery would otherwise open on slide 1
    goToVariantImage(activeVariant, 0);

    /* Centring inside the fixed frame (main-product.css, .is-framed) switches
       on one frame AFTER the paint that carries the frame and the move above.
       The only slide that can be shorter than the frame at that paint is
       slide 1 when the page opens on a taller variant shot (amla 32 oz), and
       re-centring it in the same frame as the growth counted as a shift of
       the hero image (CLS 0.31 vs 0.07 measured); by the next frame Swiper
       has moved it off-screen, so nothing visible moves. Every other slide
       first paints already centred. */
    (function frameReady() {
        var root = section.querySelector(".productVisualSwiper");
        if (!root) return;
        if (root.classList.contains("is-framed")) return;   /* 27 Sep 2026: the section printed the frame, and centring with it */
        var add = function () { root.classList.add("is-framed"); };
        if (typeof requestAnimationFrame === "function") {
            requestAnimationFrame(function () { requestAnimationFrame(add); });
        } else {
            setTimeout(add, 50);
        }
    })();

    /* ...and again once pdp-v2.js has swapped in its own gallery, which
       rebuilds at slide 0 and would otherwise discard the deep link. Watches
       for the instance to change rather than guessing at a delay; gives up
       after ~4s so a template without the enhancement costs nothing. */
    (function reapplyAfterGallerySwap() {
        var root = section.querySelector(".productVisualSwiper");
        if (!root) return;
        /* 27 Sep 2026: only markup printed before data-gallery existed can
           still see a swap (pdp-v2.js then tears this file's instance down);
           everywhere else there is one instance, opened on the right slide */
        if (galleryOwned || !document.body.classList.contains("pdp-v2")) return;
        var first = root.swiper;
        var tries = 0;
        var timer = setInterval(function () {
            if (root.swiper && root.swiper !== first) {
                goToVariantImage(activeVariant, 0);
                clearInterval(timer);
            } else if (++tries > 40) {
                clearInterval(timer);
            }
        }, 100);
    })();

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // update active variant on input changes — DELEGATED to the section:
    // app embeds (selling-plan widgets) re-render the option inputs after
    // load, which silently kills listeners bound to the elements themselves
    section.addEventListener("change", function (e) {
        if (e.target.matches("input, select")) {
            updateProduct().catch(err => console.error(err));
        }
    })

    /**************
     Update Product
     ***************/

        // see if subscription box is active
    const subscriptionBox = document.querySelector('.productFormSelling');

    function isSubscription() {
        return !!document.querySelector(`.productFormSellingOptionHeaderInput[value="sub"]:checked`);
    }

    /* 27 Sep 2026 (perf audit INP-06): every change (size, plan, quantity)
       rewrote each price, the button label and the display/opacity styles
       even when nothing had changed. Each rewrite is a DOM mutation, and the
       button's one also woke the docked bar's observer, which rewrote the
       bar. Now a node is only touched when its value actually differs; the
       end state is identical. */
    function setText(el, text) {
        if (el && el.textContent !== text) el.textContent = text;
    }
    function setStyle(el, prop, value) {
        if (el && el.style[prop] !== value) el.style[prop] = value;
    }

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productFormOptionsItem:not(.mobileOnly)`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            /* names the recovery, not just the state — this fires when the chosen
               combination does not exist, and the way out is picking another size */
            section.querySelector(".productATC").textContent = "Select another size";
            return;
        }

        /**************
         Variant Image: only SCHEDULED here (cheap), so it still happens even
         if a later step throws; the move itself runs after the price and the
         button below have painted (see scheduleVariantImage)
         ***************/

        scheduleVariantImage(activeVariant);

        /**************
         Price
         ***************/

            // if subscription turned off, skip
        const compare = section.querySelector(".productFormSellingOptionHeaderPriceCompare");
        const real = section.querySelector(".productFormSellingOptionHeaderPriceReal");
        const mainPrice = section.querySelector('.productPriceActual');
        const discountPrice = section.querySelector('.productPriceDiscount');
        if (subscriptionBox) {

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            if (isSubscription()) {
                // Update with subscription prices
                if (activeVariant.price > allocationPrice) {
                    setText(compare, price(activeVariant.price));
                    setText(discountPrice, price(activeVariant.price));
                    setStyle(discountPrice, "display", "block");
                }
                setText(real, price(allocationPrice));
                setText(mainPrice, price(allocationPrice));
                setStyle(compare, "opacity", "1");
            } else {
                // Update with one-time purchase prices
                if (activeVariant.compare_at_price > activeVariant.price) {
                    setText(compare, price(activeVariant.compare_at_price));
                    setText(discountPrice, price(activeVariant.compare_at_price));
                    setStyle(discountPrice, "display", "block");
                }
                setText(real, price(activeVariant.price));
                setText(mainPrice, price(activeVariant.price));
                setStyle(compare, "opacity", "0");
                setStyle(discountPrice, "display", "none");
            }

            /* The VISIBLE card figures are our own spans; the legacy spans this
               block writes are kept hidden (see the Liquid comment). Both cards
               were server-rendered for the first variant and never refreshed —
               Hannah caught them frozen at the 40ct prices with 100ct selected
               while the ATC updated correctly. Refresh them from the same data
               this function already holds. The saving is derived from the
               allocation Shopify actually charges, never recomputed from the
               percentage — allocations are rounded per-variant and a recompute
               can drift a cent. */
            var oncePrice = section.querySelector('[data-once-price]');
            setText(oncePrice, price(activeVariant.price));
            var subReal = section.querySelector('.pdpSubReal');
            setText(subReal, price(allocationPrice));
            var subCompare = section.querySelector('.pdpSubCompare');
            setText(subCompare, activeVariant.price > allocationPrice ? price(activeVariant.price) : '');
            var subSave = section.querySelector('[data-sub-save]');
            if (subSave) {
                var subDiff = activeVariant.price - allocationPrice;
                /* count only from an explicit "N Ct" title. A bare digit-grab would turn a
               loose-leaf "8 oz" variant into a nonsense "$1.59 per cup" when this
               template rolls out to other SKUs. No match -> the line still shows the
               saving, just without per-cup. */
            var ctMatch = String(activeVariant.title).match(/(\d+)\s*ct\b/i);
                var subCup = ctMatch ? (allocationPrice / 100 / parseInt(ctMatch[1], 10)) : null;
                setText(subSave, subDiff > 0
                    ? 'Save ' + price(subDiff) + (subCup ? ' · $' + subCup.toFixed(2) + ' per cup' : '')
                    : '');
            }
        } else {
            setText(mainPrice, price(activeVariant.price));
            setText(discountPrice, activeVariant.compare_at_price > activeVariant.price ? price(activeVariant.compare_at_price) : "");
        }


        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        var atcBtn = section.querySelector(".productATC");
        if (activeVariant.available) {
            if (atcBtn.disabled) atcBtn.disabled = false;
            setText(atcBtn, "Add To Cart");
        } else {
            if (!atcBtn.disabled) atcBtn.disabled = true;
            setText(atcBtn, "Sold Out");
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(err => console.error(err));

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelectorAll(".productQuantityControlsBtn.minus")?.forEach(el => el.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelectorAll(".productQuantityControlsValue").forEach(el => el.textContent = String(quantity));
        updateProduct().catch(err => console.error(err));
    }));

    // plus
    section.querySelectorAll(".productQuantityControlsBtn.plus")?.forEach(el => el.addEventListener("click", function () {
        quantity++;
        section.querySelectorAll(".productQuantityControlsValue").forEach(el => el.textContent = String(quantity));
        updateProduct().catch(err => console.error(err));
    }));


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productFormSellingOptionPlan').value)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productATC").classList.remove("loading");

        // open cart
        // DELIBERATELY DISABLED. Production runs a third-party cart app that
        // opens its own drawer on add to cart. Calling openCart() here opens
        // the theme's native mini-cart as well, so the customer gets two
        // carts stacked on each other.
        //
        // It was briefly enabled during sandbox work because the sandbox has
        // no cart app installed, so add to cart appeared to do nothing there.
        // That was a sandbox-only symptom. Leave this commented out.
        // await openCart();
        //
        // SANDBOX ONLY (16 Aug 2026): FGO_NATIVE_DRAWER is set in
        // theme-mini-cart.js exclusively on sandbox domains, so the line
        // below is inert on production and the rule above still holds.
        // It exists so the cart flow can be previewed and QA'd on sandbox.
        if (window.FGO_NATIVE_DRAWER && typeof openCart === "function") await openCart();
    }

    section.querySelector('.productATC').addEventListener("click", addToCart);

    // setup dropdowns
    section.querySelectorAll(".productDropdownsItemButton").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    /**************
     Universal PDP description (25 Sep 2026): Read more / Read less
     ***************
     The five-line clamp is CSS and only applies while scripting runs. This
     decides whether it is needed: text that fits loses the clamp and the
     button. Re-checked when the web font lands and when the width changes,
     because both change the line count. Only on the universal template:
     nothing else renders [data-uni-desc]. */
    var uniDesc = section.querySelector("[data-uni-desc]");
    var uniMore = section.querySelector("[data-uni-more]");
    if (uniDesc && uniMore) {
        var uniCheck = function () {
            if (uniMore.getAttribute("aria-expanded") === "true") return;
            uniDesc.classList.add("is-clamped");
            var over = uniDesc.scrollHeight - uniDesc.clientHeight > 1;
            uniDesc.classList.toggle("is-clamped", over);
            uniMore.hidden = !over;
        };
        uniCheck();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(uniCheck);
        var uniW = window.innerWidth, uniT = 0;
        window.addEventListener("resize", function () {
            if (window.innerWidth === uniW) return;   /* phones fire resize on scroll as the toolbar moves */
            uniW = window.innerWidth;
            clearTimeout(uniT);
            uniT = setTimeout(uniCheck, 150);
        });
        uniMore.addEventListener("click", function () {
            var open = uniMore.getAttribute("aria-expanded") === "true";
            uniMore.setAttribute("aria-expanded", open ? "false" : "true");
            uniDesc.classList.toggle("is-clamped", open);
            uniMore.textContent = open ? "Read more" : "Read less";
        });
    }
});
/**************
 Docked buy bar  (pdp-v2)
 ***************

 Owns no cart logic. It forwards a click to the real .productATC, so variant,
 quantity, selling plan, the Upcart drawer and the Sold Out / Not Available
 states all run through the code that is already tested. A second cart path on
 this surface is how the double-drawer bug happened; there is exactly one.

 The label and disabled state are MIRRORED, not recomputed. Two different
 scripts write that button — the theme's (Add To Cart / Sold Out / Not
 Available) and pdp-v2's price-in-label pass — so observing it is the only way
 to stay correct without betting on which one ran last.
 ***************/
(function () {
    var bar = document.querySelector('[data-buy-bar]');
    if (!bar) return;

    var realAtc = document.querySelector('.productATC');
    var barBtn  = bar.querySelector('[data-buy-bar-atc]');
    var barMeta = bar.querySelector('[data-buy-bar-meta]');
    if (!realAtc || !barBtn) return;
    /* only the universal template prints data-buy-bar-guard (see "show once
       the real button is off screen" below); read once, before the first sync */
    var guard = bar.hasAttribute('data-buy-bar-guard');

    /* ---- mirror label + disabled state ---- */
    /* 27 Sep 2026 (perf audit INP-06): sync runs on every radio change and
       on every mutation of the real button, so it now writes only what
       differs. Rewriting the same label, property and meta line each time
       was a DOM mutation per call, for no visible change. */
    function sync() {
        var label = (realAtc.textContent || '').trim();
        if (label && barBtn.textContent !== label) barBtn.textContent = label;
        if (barBtn.disabled !== realAtc.disabled) barBtn.disabled = realAtc.disabled;
        /* The price is NOT in textContent. pdp-v2.js renders it through a
           ::after fed by --atc-price, precisely because the theme rewrites
           this button with textContent on every variant change and that would
           destroy a child span. So mirror the custom property and let the same
           mechanism draw it here. */
        var atcPrice = realAtc.style.getPropertyValue('--atc-price') || '""';
        if (barBtn.style.getPropertyValue('--atc-price') !== atcPrice) barBtn.style.setProperty('--atc-price', atcPrice);
        var picked = document.querySelector('[data-purchase-pick]');
        var size   = document.querySelector('.productFormOptionsItemValuesLabelInput:checked');
        var parts  = [];
        if (size && size.value) parts.push(size.value);
        if (picked && picked.textContent.trim()) parts.push(picked.textContent.trim());
        /* the meta line already reads exactly this: nothing to rebuild */
        if (barMeta && parts.length && barMeta.textContent === parts.join(guard ? '\u00A0\u00B7 ' : ' \u00B7 ')) parts = [];
        if (barMeta && parts.length) {
            if (guard) {
                /* UNIVERSAL PDP (26 Sep 2026): each part is its own nowrap
                   span, so on a phone the line breaks only after the
                   separator ("40 Ct \u00B7" / "Subscribe & Save 15%") and never
                   ellipsises or splits the offer. The nbsp keeps the dot on
                   the first line. Styles: main-product.css, universal bar. */
                barMeta.textContent = '';
                parts.forEach(function (t, i) {
                    if (i) barMeta.appendChild(document.createTextNode('\u00A0\u00B7 '));
                    var s = document.createElement('span');
                    s.className = 'pdpBuyBarMetaPart';
                    s.textContent = t;
                    barMeta.appendChild(s);
                });
            } else {
                barMeta.textContent = parts.join(' \u00B7 ');
            }
        }
    }
    sync();

    if ('MutationObserver' in window) {
        new MutationObserver(sync).observe(realAtc, {
            childList: true, characterData: true, subtree: true, attributes: true,
            /* 'style' so the --atc-price custom property rides along — the bar
               copied it once at bind, before pdp-v2.js had set it, so the bar
               button showed no price */
            attributeFilter: ['disabled', 'style']
        });
    }
    setTimeout(sync, 400);   /* catch the late first --atc-price write */
    /* the variant/purchase radios do not touch .productATC's text, so the meta
       line needs its own trigger */
    document.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') setTimeout(sync, 0);
    });

    /* ---- one cart path ---- */
    barBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (barBtn.disabled) return;
        realAtc.click();
    });

    /* ---- show once the real button is off screen ---- */
    /* UNIVERSAL PDP (25 Sep 2026): a bar carrying data-buy-bar-guard (only the
       universal template prints it) also steps aside near the footer and while
       a cart drawer is open, and is inert while hidden. pdp-v2 / pdp-v3 do not
       carry the attribute, so for them this reduces to the original rule:
       shown exactly when the button has scrolled up out of view. (`guard` is
       read above, before the first sync.) */
    var pastAtc = false, nearFoot = false, drawerOpen = false;

    function setVisible(on) {
        bar.classList.toggle('is-in', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        /* keep it out of the tab order entirely while hidden — a focusable
           control behind an invisible bar is a keyboard trap */
        barBtn.setAttribute('tabindex', on ? '0' : '-1');
        if (guard) {
            if (on) bar.removeAttribute('inert');
            else bar.setAttribute('inert', '');
        }
    }
    function apply() {
        setVisible(pastAtc && !(guard && (nearFoot || drawerOpen)));
    }

    if ('IntersectionObserver' in window) {
        /* 26 Sep: the root is extended a long way DOWN, so "intersecting"
           means the button is in the viewport or anywhere below it, and "not
           intersecting" means exactly one thing: it has scrolled UP out of
           view. With a plain viewport root the observer stayed silent on
           phones: the button starts below the fold (not intersecting) and a
           jump past it (a #reviews anchor, a fast fling, a size picked while
           docked) lands it above the fold (still not intersecting), so no
           state changed, no callback ran and the bar never docked. Below the
           fold on first load is still not a reason to cover the page. */
        new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                pastAtc = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
                apply();
            });
        }, { threshold: 0, rootMargin: '0px 0px 100000px 0px' }).observe(realAtc);

        /* the footer is the end of the page: the bar would sit on its links.
           The theme's footer group renders as <footer>; prefer that element
           over the group's first (possibly empty) section wrapper. */
        var foot = guard ? (document.querySelector('footer') || document.querySelector('.shopify-section-group-footer-group')) : null;
        if (foot) {
            new IntersectionObserver(function (entries) {
                nearFoot = entries[0].isIntersecting;
                apply();
            }, { threshold: 0 }).observe(foot);
        }
    } else {
        /* no observer: leave it off rather than pin a bar that never hides */
        setVisible(false);
    }

    /* cart drawers: UpCart (production) puts upcartPopupShow on <body> while
       its drawer is open; the theme's own drawer (sandbox only) is the
       #miniCart dialog. Either one open means the bar steps aside. */
    if (guard && 'MutationObserver' in window) {
        var mini = document.getElementById('miniCart');
        var drawerCheck = function () {
            var open = document.body.classList.contains('upcartPopupShow') || !!(mini && mini.open);
            if (open !== drawerOpen) { drawerOpen = open; apply(); }
        };
        new MutationObserver(drawerCheck).observe(document.body, { attributes: true, attributeFilter: ['class'] });
        if (mini) new MutationObserver(drawerCheck).observe(mini, { attributes: true, attributeFilter: ['open'] });
        drawerCheck();
    }
}());

/**************
 Universal sticky add to cart  (next release, 28 Sep 2026)
 ***************

 Nate: "I would like the elderberry sticky add to cart over the pdp v2 version
 for universal sticky cart." The markup is the pdp-v4 (Elderberry) bar
 (main-product.liquid, is_uni branch); the docked bar above never binds here
 because the universal template no longer prints [data-buy-bar].

 Two things are deliberately NOT copied from fgo-pdp-v4.js:
   1. its own POST to /cart/add.js. This bar forwards to .productATC, the one
      tested cart path (variant, quantity, selling plan, drawer), exactly as the
      docked bar did. A second cart path is how the double-drawer bug happened.
   2. its show rule on phones (show whenever Add to cart is off screen, so also
      BEFORE the shopper reaches it). This keeps the universal rule: shown once
      the real button has scrolled UP out of view, hidden over the footer and
      while a cart drawer is open, inert while hidden.

 Everything it shows is READ from the buy box, never recomputed:
   size       the checked .productFormOptionsItemValuesLabelInput (first option group)
   plan       input[name$="-purchase"]:checked  (sub | once), only when the cards exist
   price      .productPriceActual   (main-product.js writes the sub or one-time price)
   compare    the Subscribe card's .pdpSubCompare, in Subscribe mode only (as pdp-v4)
   state      .productATC disabled / label / .loading
 ***************/
(function () {
    var bar = document.querySelector('[data-uni-sticky]');
    if (!bar) return;
    var section = bar.closest('.product') || document;
    var realAtc = section.querySelector('.productATC');
    var btn = bar.querySelector('[data-uni-statc]');
    if (!realAtc || !btn) return;
    var labelEl = bar.querySelector('[data-uni-stlabel]');
    var selEl = bar.querySelector('[data-uni-stsel]');
    var priceEl = bar.querySelector('[data-uni-stprice]');
    var cmpEl = bar.querySelector('[data-uni-stcompare]');
    var setText = function (el, t) { if (el && el.textContent !== t) el.textContent = t; };
    var setHidden = function (el, on) { if (el && el.hidden !== on) el.hidden = on; };
    var added = 0;   /* when the last add finished, for the pdp-v4 "Added" beat */

    function sync() {
        var off = realAtc.disabled;
        if (btn.disabled !== off) btn.disabled = off;
        /* the theme's own words for the off states ("Sold Out", "Select another
           size"), in the pdp-v4 bar's sentence case; "Add to cart" otherwise */
        var real = (realAtc.textContent || '').trim();
        var word;
        if (off) word = real ? real.charAt(0) + real.slice(1).toLowerCase() : 'Sold out';
        else if (realAtc.classList.contains('loading')) word = 'Adding';
        else if (Date.now() - added < 1600) word = 'Added';
        else word = 'Add to cart';
        setText(labelEl, word);

        var size = section.querySelector('.productFormOptionsItem:not(.mobileOnly) .productFormOptionsItemValuesLabelInput:checked');
        var buy = section.querySelector('.pdpDeliv input[name$="-purchase"]:checked');
        var parts = [];
        if (size && size.value) parts.push(size.value);
        if (buy) parts.push(buy.value === 'sub' ? 'Subscribe' : 'One time');
        setText(selEl, parts.join(' · '));

        var pr = section.querySelector('.productPriceActual');
        setText(priceEl, pr ? pr.textContent.trim() : '');
        var subCmp = section.querySelector('.pdpSubCompare');
        var cmp = (buy && buy.value === 'sub' && subCmp) ? subCmp.textContent.trim() : '';
        setText(cmpEl, cmp);
        setHidden(cmpEl, !cmp);
    }
    sync();

    var wasLoading = realAtc.classList.contains('loading');
    if ('MutationObserver' in window) {
        /* label, disabled and .loading all land on the real button; the end of
           .loading is the add finishing (main-product.js addToCart) */
        new MutationObserver(function () {
            var on = realAtc.classList.contains('loading');
            if (wasLoading && !on) { added = Date.now(); setTimeout(sync, 1650); }
            wasLoading = on;
            sync();
        }).observe(realAtc, {
            childList: true, characterData: true, subtree: true, attributes: true,
            attributeFilter: ['disabled', 'class']
        });
    }
    /* size / plan / pill changes: main-product.js writes the price inside the
       change event, fgo-buy-box.js one task later; read after both */
    section.addEventListener('change', function () { setTimeout(sync, 0); });
    setTimeout(sync, 400);   /* after main-product.js's load-time updateProduct() */

    /* ---- one cart path ---- */
    btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled || realAtc.disabled || realAtc.classList.contains('loading')) return;
        realAtc.click();
    });

    /* ---- show once the real button has scrolled up out of view ---- */
    var pastAtc = false, nearFoot = false, drawerOpen = false;
    function apply() {
        var show = pastAtc && !nearFoot && !drawerOpen;
        bar.classList.toggle('show', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        btn.setAttribute('tabindex', show ? '0' : '-1');
        if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    if ('IntersectionObserver' in window) {
        /* the root reaches far DOWN, so "not intersecting" means one thing: the
           button is above the viewport (the docked bar's 26 Sep jump-past fix) */
        new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                pastAtc = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
                apply();
            });
        }, { threshold: 0, rootMargin: '0px 0px 100000px 0px' }).observe(realAtc);
        var foot = document.querySelector('footer') || document.querySelector('.shopify-section-group-footer-group');
        if (foot) {
            new IntersectionObserver(function (entries) {
                nearFoot = entries[0].isIntersecting;
                apply();
            }, { threshold: 0 }).observe(foot);
        }
    }
    /* cart drawers: UpCart (production) puts upcartPopupShow on <body>; the
       sandbox's native drawer is the #miniCart dialog */
    if ('MutationObserver' in window) {
        var mini = document.getElementById('miniCart');
        var drawerCheck = function () {
            var open = document.body.classList.contains('upcartPopupShow') || !!(mini && mini.open);
            if (open !== drawerOpen) { drawerOpen = open; apply(); }
        };
        new MutationObserver(drawerCheck).observe(document.body, { attributes: true, attributeFilter: ['class'] });
        if (mini) new MutationObserver(drawerCheck).observe(mini, { attributes: true, attributeFilter: ['open'] });
        drawerCheck();
    }
}());

/**************
 Universal PDP reviews slot  (27 Sep 2026, 26 Sep universal verify V2)
 ***************

 templates/product.universal.json wraps the Yotpo main widget in a
 .pdpReviewsSlot that reserves its 530px empty state on desktop, and let the
 reservation go with an 8 s CSS animation. Measured on the sandbox (desktop,
 27 Sep): Yotpo renders at ~0.9 s at exactly 530px, so when Yotpo works the
 timer changed nothing; when Yotpo is blocked or fails, the slot collapsed
 530px at 8 s, under whatever the visitor was reading by then.

 The reservation now ends on evidence: once the widget has painted content
 and held its size for 600 ms, the slot drops its min-height (with a working
 Yotpo, 530px of content in a 530px slot, so nothing moves). The inline
 animation:none is what cancels the template's timer; the template still
 sets the 530px. The timer survives only as a last resort: after 8 s with
 nothing rendered it releases only while the slot is wholly below the
 viewport, where the collapse moves nothing on screen, and otherwise waits
 until it is. Phones (<=800px) carry no reservation and are left alone. If
 this file fails to load, the template's own 8 s rule still applies.
 ***************/
(function () {
    var slot = document.querySelector('.pdpReviewsSlot');
    if (!slot || !('ResizeObserver' in window) || !('IntersectionObserver' in window) || !window.matchMedia) return;
    if (window.matchMedia('(max-width: 800px)').matches) return;
    slot.style.animation = 'none';

    var done = false, lastResort = false, below = false, settleTimer = 0, lastResortTimer = 0;
    var ro = null, io = null, mo = null;
    function release() {
        if (done) return;
        done = true;
        slot.style.minHeight = '0px';
        clearTimeout(settleTimer);
        clearTimeout(lastResortTimer);
        if (ro) ro.disconnect();
        if (io) io.disconnect();
        if (mo) mo.disconnect();
    }

    /* evidence: any child of the slot (Yotpo swaps its placeholder for a
       .yotpo-widget-instance) reports a painted height */
    ro = new ResizeObserver(function (entries) {
        var tall = false;
        for (var i = 0; i < entries.length; i++) {
            if (entries[i].contentRect.height > 0) tall = true;
        }
        if (!tall) return;
        clearTimeout(settleTimer);
        settleTimer = setTimeout(release, 600);
    });
    var watch = function () {
        for (var i = 0; i < slot.children.length; i++) ro.observe(slot.children[i]);
    };
    watch();
    mo = new MutationObserver(watch);
    mo.observe(slot, { childList: true });

    /* last resort, only where it cannot be seen */
    io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        var bottom = e.rootBounds ? e.rootBounds.bottom : window.innerHeight;
        below = !e.isIntersecting && e.boundingClientRect.top >= bottom;
        if (lastResort && below) release();
    });
    io.observe(slot);
    lastResortTimer = setTimeout(function () {
        lastResort = true;
        if (below) release();
    }, 8000);
}());
